"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class KeyValue extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => String),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: 'key', description: 'Key of the keyvalue pair' }),
    tslib_1.__metadata("design:type", String)
], KeyValue.prototype, "key", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => String),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({ example: 'value', description: 'Value of the keyvalue pair' }),
    tslib_1.__metadata("design:type", String)
], KeyValue.prototype, "value", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: false, description: 'Whether this keyValue pair is required or not' }),
    tslib_1.__metadata("design:type", Boolean)
], KeyValue.prototype, "required", void 0);
exports.default = KeyValue;
